export default __webpack_public_path__ + "static/media/nagarqr.94189e10.png";